import { LoadingView } from 'components';

import { SigningContract } from '../components';
import { useSigningContract } from '../hooks/useSigningContract';
import { PageComponentProps } from '../types';

export const SigningContractStep = ({ canGoBack }: PageComponentProps) => {
  const {
    initialValues,
    files,
    submitLoading,
    submitDisabled,
    contractFileHref,
    onSubmit,
    goToBack,
    onAddFiles,
    onRemoveFile,
  } = useSigningContract();

  if (!contractFileHref) {
    return <LoadingView />;
  }

  return (
    <SigningContract
      canGoBack={canGoBack}
      contractFileHref={contractFileHref}
      files={files}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
